import { Icon, IconName } from '~/modules/elements/akui/icon';

export function EmptyState({
  icon,
  title,
  body,
  cta,
  onCta,
  test,
}: {
  icon: IconName;
  title: string;
  body: string;
  cta: string;
  onCta: () => void;
  test: string;
}) {
  return (
    <div className="flex flex-col items-center gap-2 px-8 py-12 text-center" data-test={test}>
      <Icon icon={icon} size={10} className="text-white/45" />
      <span className="text-[1.125rem] font-bold">{title}</span>
      <span className="ph-no-capture text-[0.9375rem] leading-[1.45] text-white/75">{body}</span>
      <button
        type="button"
        onClick={onCta}
        data-test={`${test}-action`}
        className="mt-2 flex h-12 cursor-pointer items-center justify-center rounded-[0.875rem] border-none bg-black/50 px-5 text-[0.9375rem] text-white shadow-[inset_0_0_0_1px_rgba(255,255,255,0.14)]">
        {cta}
      </button>
    </div>
  );
}

const SKELETON_WIDTHS = [70, 55, 80, 45, 65, 75, 50, 60];

export function SkeletonRows() {
  return (
    <div data-test="song-list-loading" aria-hidden>
      {SKELETON_WIDTHS.map((width, index) => (
        <div
          key={index}
          className="grid h-19 grid-cols-[3.5rem_minmax(0,1fr)_auto] items-center gap-3 border-b border-white/6 pr-3 pl-4">
          <span className="size-14 rounded-[0.625rem] bg-white/8" />
          <span className="flex flex-col gap-2">
            <span className="h-3.5 rounded-md bg-white/12" style={{ width: `${width}%` }} />
            <span
              className="h-2.5 rounded-[0.3125rem] bg-white/7"
              style={{ width: `${width - 20 + (index % 3) * 8}%` }}
            />
          </span>
          <span className="flex gap-1.5">
            <span className="size-10 rounded-xl bg-white/6" />
            <span className="size-10 rounded-xl bg-white/6" />
          </span>
        </div>
      ))}
    </div>
  );
}
